import { Reducer } from 'redux';

// Helpers
import { getCurrentPath } from 'helpers/drawer';

// Types
import { RouteTypes, RouteState } from './types';

const INITIAL_STATE: RouteState = {
  routeActive: getCurrentPath()!,
};

const reducer: Reducer<RouteState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES ROUTE ACTIVE
    case RouteTypes.SET_ROUTE_ACTIVE:
      return {
        ...state,
        routeActive: action.payload.routeActive,
      };

    default:
      return state;
  }
};

export default reducer;
